module.exports = __webpack_public_path__ + "static/media/miniStories_16.6995dd1f.webp";